export default __webpack_public_path__ + "static/media/vines.1aa81de7.png";